import CardPerks from './card-perks';

export default CardPerks;
